export const EVENT_ONE_TAP_GOOGLE_IFRAME_LOAD_FAILED =
  'google yolo iframe failed to load';
export const EVENT_ONE_TAP_GOOGLE_IFRAME_CLOSED =
  'google yolo iframe closed by user';

// The apps we consider part of the "google suite"
export const GOOGLE_SUITE_APPS = [
  'GoogleCalendarAPI',
  'GoogleContactsCLIAPI',
  'GoogleDocsV2API',
  'GoogleDriveAPI',
  'GoogleMailV2API',
  'GoogleSheetsV2API',
  'GoogleFormsV2API',
  'GoogleSlidesDevAPI',
];
